<template>
  <div class="img col-sm-12">
    <img src="../assets/IMG/Fondo_peq.png" alt="Fondo" />

    <div class="tx-text text-center">
      <h1 class="headline">
        MY WORD
      </h1>
    </div>
  </div>
</template>

<script>
export default { name: "Everybody" };
</script>

<style scoped>
.img {
  position: relative;
  width: 100%;
  display: block;
  background-color: #efefe4;
  margin: 0;
  padding: 0;
}

.img::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 50% 48%,
    rgba(0, 0, 0, 0.14) 0%,
    rgba(0, 0, 0, 0.08) 58%,
    rgba(0, 0, 0, 0.02) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.img img {
  width: 100%;
  height: auto;
  display: block;
}

.tx-text {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(1260px, 96%);
  text-align: center;
}

.headline {
  position: relative;
  display: inline-block;
  margin: 0;
  line-height: 0.88;
  letter-spacing: 0.07em;
  color: #f4f1df;
  text-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
  font-family: "Barlow", sans-serif;
    font-family: "CocomatPro", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: clamp(48px, 9vw, 140px);
    transform: none;
    animation: heroIn 650ms ease both;
}


@media (hover: hover) {
    .headline:hover {
      transform: translateY(-2px);
      transition: transform 180ms ease;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .tx-text {
    top: 51%;
    width: min(980px, 94%);
  }

  .headline {
    font-size: clamp(62px, 11vw, 150px);
    letter-spacing: 0.06em;
  }

}

@media (max-width: 767px) {
  .img {
    height: 100vh;
    min-height: 320px;
    width: 100vw;
    left: 0;
    margin: 0;
    padding: 0;
  }

  .img img {
    width: 100vw;
    height: 100vh;
    min-height: 320px;
    object-fit: cover;
    object-position: center;
    left: 0;
    margin: 0;
    padding: 0;
    display: block;
  }

  .tx-text {
    top: 52%;
    width: 96%;
  }

  .headline {
    line-height: 0.9;
    font-size: clamp(58px, 16.5vw, 118px);
    letter-spacing: 0.05em;
  }
}

@media (max-width: 420px) {
  .img {
    height: 255px;
  }

  .tx-text { top: 53%; }

  .headline { font-size: clamp(50px, 15.5vw, 90px); }
}

@keyframes heroIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
    filter: blur(1px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .headline { animation: none; }
}
</style>
